import React from 'react';

const AllTicketsContext = React.createContext('ticket');

export const AllTicketsContextProvider = AllTicketsContext.Provider;

export default AllTicketsContext;
